import ReactDOM from 'react-dom';

export default function DropdownPortal({ children, rect, onClose }) {
  if (!rect) return null;
  const style = { position: 'fixed', top: `${rect.bottom + 5}px`, left: `${rect.right - 160}px`, zIndex: 999999 };
  return ReactDOM.createPortal(
    <>
      <div style={{ position: 'fixed', inset: 0, zIndex: 999998 }} onClick={onClose} />
      <div className="export-menu-portal" style={style}>{children}</div>
    </>,
    document.body
  );
}
